export { default as Workplaces } from './workplaces.container';
export { WorkplaceDetails } from './workplacesDetails.component';
